import {twMerge} from '../../../common/twMerge';
import {theme} from '../../../theme';
import {Text} from '../../atoms/Text/Text';
import {WaitfreeProgressBarProps} from './WaitfreeProgressBar.interface';

export function WaitfreeProgressBar({
  ratio,
  remainText,
  className,
  ...props
}: WaitfreeProgressBarProps) {
  const fillPercentage = ratio * 100;

  return (
    <div
      {...props}
      className={twMerge(
        'flex h-28pxr w-fit-content items-center justify-center overflow-hidden rounded-[100px] border-1 border-theme-solid-20 px-12pxr',
        className
      )}
      style={{
        background: `linear-gradient(90deg, ${theme.colors['theme-solid-20']} 0%, ${theme.colors['theme-solid-20']} ${fillPercentage}%, rgba(0,0,0,0) ${fillPercentage}%, rgba(0,0,0,0) 100%)`,
      }}
    >
      <Text className="font-small2 text-theme-solid-100">{remainText}</Text>
    </div>
  );
}
